import React, { useEffect, useRef, useState } from 'react';
let scriptPromise;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => { script.remove(); scriptPromise = undefined; reject(new Error('Unable to load verification')); };
    document.head.appendChild(script);
  });
  return scriptPromise;
}
export default function Turnstile({ onToken, onStatus }) {
  const container = useRef(null);
  const callback = useRef(onToken);
  callback.current = onToken;
  const statusCallback = useRef(onStatus);
  statusCallback.current = onStatus;
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true, widget;
    const sitekey = process.env.REACT_APP_CLOUDFLARE_SITE_KEY;
    callback.current('');
    setError('');
    statusCallback.current?.('loading');
    const showError = message => { callback.current(''); setError(message); statusCallback.current?.('error'); };
    if (!sitekey) { showError('Our quick check isn’t available right now. Please try again in a moment.'); return; }
    loadTurnstile().then(api => {
      if (!active) return;
      widget = api.render(container.current, {
        sitekey, action: 'site_access', size: 'flexible', appearance: 'interaction-only', 'response-field': false,
        'before-interactive-callback': () => { if (active) statusCallback.current?.('interactive'); },
        'after-interactive-callback': () => { if (active) statusCallback.current?.('loading'); },
        callback: token => { if (active) { setError(''); statusCallback.current?.('complete'); callback.current(token); } },
        'expired-callback': () => { if (active) showError('The check timed out. Give it another try when you’re ready.'); },
        'timeout-callback': () => { if (active) showError('The check took a little too long. Please try again.'); },
        'error-callback': () => { if (active) showError('The check hit a small snag. Please try again.'); },
      });
    }).catch(() => { if (active) showError('We couldn’t load the quick check. Check your connection and try again.'); });
    return () => { active = false; if (widget !== undefined && window.turnstile) window.turnstile.remove(widget); };
  }, [attempt]);
  return <div style={{ width: '100%', maxWidth: 360, margin: '16px auto' }}>
    <div ref={container} />
    {error && <><p role="alert">{error}</p><button type="button" onClick={() => setAttempt(value => value + 1)}>Try again</button></>}
  </div>;
}
